import { render } from "./firstLayer.vue?vue&type=template&id=be2c63f6&lang=pug&bindings={}"
import script from "./firstLayer.vue?vue&type=script&lang=js"
export * from "./firstLayer.vue?vue&type=script&lang=js"

import "./firstLayer.vue?vue&type=style&index=0&lang=sass"
script.render = render

export default script